import { render, staticRenderFns } from "./Wishlist.vue?vue&type=template&id=751afc20&scoped=true"
import script from "./Wishlist.vue?vue&type=script&lang=js"
export * from "./Wishlist.vue?vue&type=script&lang=js"
import style0 from "./Wishlist.vue?vue&type=style&index=0&id=751afc20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751afc20",
  null
  
)

export default component.exports